export default [{
    title: "Administración",
    fontIcon: "folder",
    resource: "Administracion",
    action: "ver-administracion",
    children: [
        {
            title: "Configuracion",
            icon: "SettingsIcon",
            resource: "Administracion",
            action: "ver-administracion-configuracion",
            children: [
            {
                route: "administracion-configuracion-permisos",
                title: "Permisos",
                fontIcon: "clipboard-list",
                resource: "Administracion",
                action: "ver-administracion-configuracion-permisos",
            },
            {
                route: "administracion-configuracion-autorizaciones",
                title: "Autorizaciones",
                fontIcon: "clipboard-list",
                resource: "Administracion",
                action: "ver-administracion-configuracion-autorizaciones",
            }
        ]
        },
        {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Administracion",
            action: "ver-administracion-mantenimiento",
            children: [{
                route: "administracion-mantenimiento",
                title: "Mantenimiento",
                fontIcon: "file-circle-check",
                resource: "Administracion",
                action: "ver-administracion-mantenimiento",
            },
            ]
        },
        {
            title: "Transacciones",
            fontIcon: "exchange-alt",
            resource: "Administracion",
            action: "ver-administracion-transacciones",
            children: [
                {
                    route: "administracion-transacciones-aprobaciones",
                    title: "Aprobaciones",
                    fontIcon: "circle-check",
                    resource: "Administracion",
                    action: "ver-administracion-transacciones-aprobaciones",
                }
            ]
        },
    ]
}, ]